import { Chip } from '@mui/material';
import { useMaterialUIController } from 'context';
import { getCrmColors } from '../../kanban-board/crm-theme';

interface Props {
    label: string;
    color: 'success' | 'warning' | 'error' | 'default';
}

/// Situação de cobrança e de assinatura: contorno colorido e texto neutro (na cor do chip, apagava).
export const LeadStatusChip = ({ label, color }: Props) => {
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);

    return (
        <Chip
            label={label}
            size="small"
            color={color}
            variant="outlined"
            sx={{ height: 22, fontSize: 11, '& .MuiChip-label': { color: cc.onTint } }}
        />
    );
};
